'use client';

import { Suspense, lazy, useSyncExternalStore } from 'react';

// Lazy load the main content with a very simple loading fallback
const AppContent = lazy(() => import('@/components/blog/HomeContent'));

// Use useSyncExternalStore for hydration-safe mounted check (no setState in effect)
const emptySubscribe = () => () => {};
function useMounted() {
  return useSyncExternalStore(
    emptySubscribe,
    () => true,
    () => false
  );
}

export default function Home() {
  const mounted = useMounted();
  
  if (!mounted) {
    return (
      <div className="min-h-screen flex flex-col bg-background text-foreground">
        <header className="sticky top-0 z-50 border-b border-border bg-background/95 backdrop-blur h-16 flex items-center px-4 sm:px-6">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 bg-primary/20 rounded-full" />
            <span className="text-xl font-bold">Cyber<span className="text-primary">Defensa</span></span>
          </div>
        </header>
        <main className="flex-1 flex items-center justify-center">
          <div className="text-center">
            <p className="text-muted-foreground text-sm">Cargando...</p>
          </div>
        </main>
        <footer className="mt-auto border-t border-border h-24" />
      </div>
    );
  }
  
  return (
    <Suspense fallback={
      <div className="min-h-screen flex flex-col bg-background text-foreground">
        <header className="sticky top-0 z-50 border-b border-border bg-background/95 backdrop-blur h-16 flex items-center px-4 sm:px-6">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 bg-primary/20 rounded-full animate-pulse" />
            <span className="text-xl font-bold">Cyber<span className="text-primary">Defensa</span></span>
          </div>
        </header>
        <main className="flex-1 flex items-center justify-center">
          <div className="text-center">
            <div className="h-8 w-48 bg-secondary/50 rounded animate-pulse mx-auto mb-4" />
            <p className="text-muted-foreground text-sm">Cargando artículos...</p>
          </div>
        </main>
        <footer className="mt-auto border-t border-border h-24" />
      </div>
    }>
      <AppContent />
    </Suspense>
  );
}
